const serviceCards = [
  { 
    cardType: 'Web Design',
    cardImage: require('./../../Assets/Icons/bx_globe-alt.svg').default,
    header: 'Web Design',
    text: 'I design the layout reference for the project, so it can be satisfactory according to the customers tastes, but also to be visually appealing'
  },

  //{
  //  cardType: 'Mobile Apps',
  //  cardImage: require('./../../Assets/Icons/clarity_mobile-phone-line.svg').default,
  //  header: 'Mobile Apps',
  //  text: 'Separated they live in Bookmarksgrove right at the coast of the Semantics'
  //},

  {
    cardType: 'Development',
    cardImage: require('./../../Assets/Icons/iconoir_pc-check.svg').default,
    header: 'Development',
    text: 'The project will be created and developed after both sides agree on the design of the project, and can then be deployed'
  }
];

module.exports = serviceCards;